import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Pagination, PageHeader, paginate } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { CSVLink, CSVDownload } from "react-csv";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { PlukingChecklistReportSchema } from "../PlukingChecklistReportSchema";
import { HalfNameMarkReportTableContent } from '../../../Common/Table/tableContent';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import CreatePdf from './createPdf';
import ReactToPrint from "react-to-print";
import { saveAs } from 'file-saver';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import { InputAdornment, Box } from '@material-ui/core';
import Search from '@mui/icons-material/Search';
import _ from 'lodash';

const screenCode = 'PLUCKINGCHECKLISTREPORT'

export function PlukingChecklistReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [gang, setGang] = useState([]);
    const [collectionCategory, setCollectionCategory] = useState([]);
    const [subNames, setSubNames] = useState([]);
    const [colName, setColName] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "",
        operationEntityID: "",
        collectionPointID: "",
        pluckingType: "0",
        gangID: "0",
        date: "",
    });
    const [customSearch, setCustomSearch] = useState({
        regNumber: ''
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        operationEntity: "",
        collectionPoint: ""
    });
    const [summeryValues, setSummeryValues] = useState({
        full: 0,
        half: 0,
        allTotal: 0,
        okTot: 0
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(PlukingChecklistReportSchema).options({ allowUnknown: true });
    const contentRowNames = ["employeeName", "registrationNumber", "cardNumber", "totalWeight", "reason", "lastWeighTime"]

    const [csvHeaders, setCsvHeaders] = useState([]);

    const [data, setdata] = useState([]);
    const [data1, setdata1] = useState([]);
    const [summeryData, setSummeryData] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [searchButtonHide, setSearchButtonHide] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
        resetDropDowns(DropdownChanges.group);
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getGangByCollectionPointID()
        )
    }, [searchData.collectionPointID])

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropDown()
        )
        getCollectionPointsForDropDown();
        resetDropDowns(DropdownChanges.operationEntity);
    }, [searchData.operationEntityID])

    useEffect(() => {
        handleSearch1(customSearch.regNumber);
    }, [customSearch.regNumber]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWPLUKINGCHECKLISTREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    function resetDropDowns(type) {
        if (type === DropdownChanges.operationEntity) {
            setsearchData({
                ...searchData,
                collectionPointID: "0",
            });
        } else if (type === DropdownChanges.group) {
            setsearchData({
                ...searchData,
                operationEntityID: "0",
                collectionPointID: "0",
            });
        }
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionCategory = await service.getCollectionCategoryByOperationEntityForDropDown(searchData.operationEntityID);
        setCollectionCategory(collectionCategory);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    async function getGangByCollectionPointID() {
        const gang = await service.getGangByCollectionPointID(searchData.operationEntityID, searchData.collectionPointID);
        setGang(gang);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;
        const error = { ...errors };
        const errorMessage = validateProperty(target, PlukingChecklistReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
        clearTableRelatedData();
    }

    async function handleSearch(e) {
        e.preventDefault();

        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        let result = await service.getReportData(searchData.collectionPointID, searchData.pluckingType, searchData.gangID, searchData.date);
        formatResult(result);
        getSelectedDropdownValuesForReport(searchData);

    }

    function formatResult(data) {
        var result = [];
        var totalOfAllrecords = 0;
        var names = [];
        var csvHeaders = [
            { label: "Reg Number", value: "registrationNumber" },
            { label: "Employee Name", value: "firstName" }
        ];
        data.forEach(x => {

            var sessionName = x.sessionName;

            if (result.length === 0) {
                result.push({
                    [sessionName]: checkUndifind(x.totalAmount),
                    employeeID: parseInt(x.employeeID),
                    registrationNumber: x.registrationNumber,
                    firstName: x.firstName,
                    total: checkUndifind(x.totalAmount),
                    configurationValue: x.configurationValue
                });
                names.push(x.sessionName);
                csvHeaders.push({ label: x.sessionName, value: x.sessionName });
                totalOfAllrecords = totalOfAllrecords + parseFloat(x.totalAmount);
            } else {
                totalOfAllrecords = totalOfAllrecords + parseFloat(x.totalAmount);
                var duplicate = result.find(y => parseInt(y.employeeID) == parseInt(x.employeeID));

                var duplicateName = names.find(y => y === x.sessionName);

                if (!duplicateName) {
                    names.push(x.sessionName);
                    csvHeaders.push({ label: x.sessionName, value: x.sessionName });
                }

                if (duplicate) {
                    duplicate[sessionName] = checkUndifind(duplicate[sessionName]) + checkUndifind(x.totalAmount);
                    duplicate.registrationNumber = x.registrationNumber;
                    duplicate.firstName = x.firstName;
                    duplicate.configurationValue = x.configurationValue;
                    duplicate.total = checkUndifind(duplicate.total) + checkUndifind(x.totalAmount);
                } else {
                    result.push({
                        [sessionName]: checkUndifind(x.totalAmount),
                        employeeID: parseInt(x.employeeID),
                        registrationNumber: x.registrationNumber,
                        firstName: x.firstName,
                        total: checkUndifind(x.totalAmount),
                        configurationValue: x.configurationValue
                    });
                }
            }
        });
        names.sort((a, b) => a > b ? 1 : -1);

        csvHeaders.push({ label: "Total", value: "total" });
        if (searchData.pluckingType == 'GENERAL') {
            csvHeaders.push({ label: "Mandays", value: "duration" });
            csvHeaders.push({ label: "Cash Kilo", value: "overKilo" });
        }

        var result2 = [];

        result.forEach(x => {
            names.forEach(y => {
                if (x[y]) {
                    result2.push({
                        property: y,
                        value: checkUndifind(x[y])
                    });

                }
            });
        });

        const result3 = result2.reduce((obj, el) => {

            obj[el.property] = (obj[el.property] || 0) + el.value;

            return obj;
        }, {});

        const result4 = result.filter(x => x.total >= x.configurationValue);

        let okTot = 0;
        result.forEach(x => {
            if (!((parseFloat(x.total) - parseFloat(x.configurationValue)) <= 0)) {
                okTot = okTot + (parseFloat(x.total) - parseFloat(x.configurationValue));
            }
        });

        setSummeryValues({
            ...summeryValues,
            full: result4.length,
            half: result.length - result4.length,
            allTotal: totalOfAllrecords,
            okTot: okTot
        });

        setCsvHeaders(csvHeaders);
        setSubNames(names);
        setdata(result);
        setdata1(result);
        setCsvData(result);
        setColName(names);

        var resultqqqq = Object.entries(result3);

        var temlArry = [];
        for (const key in resultqqqq) {
            temlArry.push({
                name: resultqqqq[key][0],
                value: resultqqqq[key][1]
            })
        }
        temlArry.sort((a, b) => a.name > b.name ? 1 : -1);
        setSummeryData(temlArry);

    }

    function checkUndifind(value) {
        if (value === undefined) {
            return 0;
        }
        else {
            return value;
        }
    }

    function createFile() {
        var settings = {
            sheetName: 'Plucking Checklist Report',
            fileName: 'PluckingChecklistReport',
            writeOptions: {}
        }
        csvData.forEach(x => {
            x.duration = x.total >= x.configurationValue ? 'Full' : 'Half'
            x.overKilo = (parseFloat(x.total) - parseFloat(x.configurationValue)) <= 0 ? '' :
                (parseFloat(x.total) - parseFloat(x.configurationValue))
        });

        var newArray1 = {
            registrationNumber: "Total",
            total: summeryValues.allTotal,
            overKilo: summeryValues.okTot
        }

        summeryData.forEach(x => {
            newArray1[x.name] = x.value;
        });

        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            registrationNumber: "Group :" + groups[searchData.groupID],
            firstName: "Operation Entity : " + operationEntity[searchData.operationEntityID],
        }
        var newRow2 = {
            registrationNumber: "Collection Point :" + collectionPoint[searchData.collectionPointID],
            firstName: "Date : " + searchData.date,
        }
        var newRow3 = {
            registrationNumber: "Generated date/time : " + new Date().toLocaleString(),
            firstName: "Generated user : " + tokenService.getUserNameFromToken(),
        }
        if (searchData.pluckingType == 'GENERAL') {
            var newRow4 = {
                registrationNumber: "Full : " + summeryValues.full,
                firstName: "Half : " + summeryValues.half,
            }
        }

        copyOfCsv.push(newArray1, {}, searchData.pluckingType == 'GENERAL' ? newRow4 : {}, {}, newRow1, newRow2, newRow3)

        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            operationEntity: operationEntity[searchForm.operationEntityID],
            collectionPoint: collectionPoint[searchForm.collectionPointID],
            pluckingType: searchForm.pluckingType,
            date: searchForm.date
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function onCancelClick() {
        setsearchData({
            ...searchData,
            collectionPointID: "0",
        });

        clearTableRelatedData();
    }

    function clearTableRelatedData() {
        setdata([]);
        setIsTableHide(true);
        setSelectedSearchValues([]);
    }

    function handleChange1(e) {
        const target = e.target;
        const value = target.value
        setCustomSearch({
            ...customSearch,
            regNumber: value
        });
    }

    async function handleSearch1(data2) {
        if (data == null || data.length == 0) {
            setdata(data1)
        }
        const Default = data.filter(x => x.registrationNumber.toLowerCase().includes(data2.toLowerCase()) || x.firstName.toLowerCase().includes(data2.toLowerCase()))
        if (data2 == '') {
            setdata(data1)
            return;
        }
        setdata(Default)
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Pluking Checklist Report"
                                isButtonEnable={false}
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Collection point *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection point--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="gangID">Gang</InputLabel>
                                    <Select
                                        fullWidth
                                        id="gangID"
                                        name="gangID"
                                        value={searchData.gangID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Gang--</MenuItem>
                                        {generateDropDownMenu(gang)}
                                    </Select>
                                    {errors["gangID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["gangID"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="pluckingType">Plucking Type</InputLabel>
                                    <Select
                                        id="pluckingType"
                                        select
                                        fullWidth
                                        name="pluckingType"
                                        onChange={(e) => handleChange(e)}
                                        value={searchData.pluckingType}>
                                        <MenuItem value="0">--Select Plucking Type--</MenuItem>
                                        <MenuItem value="GENERAL">General</MenuItem>
                                        <MenuItem value="RSM">RSM</MenuItem>
                                        <MenuItem value="CASH">Cash</MenuItem>
                                        <MenuItem value="KILO">Kilo</MenuItem>
                                    </Select>
                                    {errors["pluckingType"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["pluckingType"]}</FormHelperText>)}
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="searchDate">Date *</InputLabel>
                                    <TextField
                                        fullWidth
                                        id="date"
                                        name="date"
                                        type="date"
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                </div>

                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        disabled={validate(schema, searchData)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                        hidden={searchButtonHide}
                                    />
                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </div>
                        </form>
                        {data.length != 0 ?
                            <Card>
                                <Box display="flex" flexDirection="row-reverse" p={2} >
                                    <TextField
                                        size="small"
                                        style={{ width: '300px' }}
                                        value={customSearch.regNumber}
                                        placeholder="Search"
                                        onChange={(e) => { handleChange1(e) }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                                <TableContainer component={Paper}>
                                    <div className="row alternative_cls bg-light  ">
                                        {searchData.pluckingType == 'GENERAL' ?
                                            <div className="card-body width1"><p><b><p />Full :</b> {summeryValues.full} </p> </div>
                                            : null}
                                        {searchData.pluckingType == 'GENERAL' ?
                                            <div className="card-body width1"><p><b><p />Half : </b>{(summeryValues.half)/2}</p> </div>
                                            : null}
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Reg No
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Employee Name
                                                    </TableCell>
                                                    {colName.map((item) => (
                                                        <TableCell style={{ fontWeight: "bold" }} align='center'>
                                                            {item} (Kg)
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Total
                                                    </TableCell>
                                                    {searchData.pluckingType == 'GENERAL' ?
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                            Mandays
                                                        </TableCell> : null}
                                                    {searchData.pluckingType == 'GENERAL' ?
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                            Cash Kilo
                                                        </TableCell> : null}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow key={row.registrationNumber}>
                                                        <TableCell component="th" align="left" >
                                                            {row.registrationNumber}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {row.firstName}
                                                        </TableCell>
                                                        {subNames.map((column) => {
                                                            const value = row[column];
                                                            return (
                                                                <TableCell align='right'>{value == undefined ? '-' : parseFloat(value).toFixed(2)}</TableCell>
                                                            );
                                                        })}
                                                        <TableCell align="center">{parseFloat(row.total).toFixed(2)}</TableCell>
                                                        {searchData.pluckingType == 'GENERAL' ?
                                                            <TableCell align="center">{row.total >= row.configurationValue ? '1' : '0.5'}</TableCell>
                                                            : null}
                                                        {searchData.pluckingType == 'GENERAL' ?
                                                            <TableCell align="center">{(parseFloat(row.total) - parseFloat(row.configurationValue)) <= 0 ? '-'
                                                                : (parseFloat(row.total) - parseFloat(row.configurationValue)).toFixed(2)}</TableCell> : null}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={2} style={{ fontWeight: "bold" }} align="left">
                                                        Total
                                                    </TableCell>
                                                    {summeryData.map((item) => (
                                                        <TableCell style={{ fontWeight: "bold" }} align="right">
                                                            {parseFloat(item.value).toFixed(2)}
                                                        </TableCell>
                                                    ))}
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        {parseFloat(summeryValues.allTotal).toFixed(2)}
                                                    </TableCell>
                                                    {searchData.pluckingType == 'GENERAL' ?
                                                        <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        </TableCell> : null}
                                                    {searchData.pluckingType == 'GENERAL' ?
                                                        <TableCell style={{ fontWeight: "bold" }} align="center">
                                                            {parseFloat(summeryValues.okTot).toFixed(2)}
                                                        </TableCell> : null}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </div>
                                </TableContainer>
                            </Card>
                            : null}
                    </div>
                    {data.length != 0 ?
                        <div className="pt-2">
                            <ReactToPrint
                                documentTitle={"Plucking Checklist Report"}
                                trigger={() => <input
                                    type="button"
                                    className="btn btn-primary pull-right ml-2"
                                    value="PDF"

                                />}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePdf ref={componentRef} searchData={selectedSearchValues} contentRowNames={subNames} data={data}
                                    initialData={colName} summeryValues={summeryValues} summeryData={summeryData}
                                />
                            </div>
                            <input
                                type="button"
                                className="btn btn-primary pull-right ml-2"
                                value="Excel"
                                onClick={createFile}
                            />

                        </div>
                        : null}
                </div>
            </div>
        </Fragment >
    );
}



